/**
 * Auto-generated Atom and Entity Infos
 */

import { CONTEXT_KEY } from "@atoms/atom-types";
import { DefaultAtoms, DefaultEntities } from "@atoms/atom-types";
import { Atoms } from "../enums/atoms";
import { Entities } from "../enums/entities";
import { UserState } from "@atoms/atom-types";

// Extended atom infos with default values
export const atomInfosExtended = {
  [Atoms.ImportProtocol]: {
    entityType: Entities.ImportProcess,
  },
  [Atoms.OrderInfo]: {
    entityType: Entities.Order,
  },
  [Atoms.OrderPositions]: {
    entityType: Entities.Order,
  },
  [Atoms.PositionInfo]: {
    entityType: Entities.Position,
    defaultValues: {
      "amount": 1,
      "articleId": null,
      "claimee": null,
      "commodityGroup": "",
      "compartments": null,
      "createdAt": new Date(),
      "customer": "",
      "deleted": false,
      "description": "",
      "division": "",
      "editedAt": null,
      "importReport": null,
      "manualChanges": null,
      "manufacturer": "",
      "megaCaseInfo": null,
      "metaInfo": null,
      "model": "",
      "orderNumber": "",
      "previewImageUrl": null,
      "price": null,
      "priceParameters": null,
      "requiredPresets": undefined,
      "source": "",
      "userDefinedOptions": null,
      "variant": "",
    },
    requireExplicitWritePermissionFields: ["createdAt", "source"],
  },
  [Atoms.PresetInfo]: {
    entityType: Entities.Preset,
    defaultValues: {
      "category": "",
      "data": {},
      "deleted": false,
      "name": "",
      "productType": "",
      "tags": undefined,
    },
    requireExplicitWritePermissionFields: ["tags"],
    requireExplicitWritePermissionCustomPermissions: {
      "tags": "custom:ManageTaggedPresets",
    },
  },
  [Atoms.PresetList]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.PriceData]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.PriceParameters]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.RecentImports]: {
    entityType: DefaultEntities.Global,
  },
  [Atoms.UserOptionInfo]: {
    entityType: Entities.UserOption,
    defaultValues: {
      "aliases": undefined,
      "deleted": false,
      "description": "",
      "kind": "",
      "meshes": undefined,
      "name": "",
    },
  },
  [Atoms.UserOptionsList]: {
    entityType: DefaultEntities.Global,
  },
  [DefaultAtoms.ApiTokens]: {
    entityType: DefaultEntities.User,
  },
  [DefaultAtoms.FrontendConfig]: {
    entityType: DefaultEntities.Global,
  },
  [DefaultAtoms.PersonalUserData]: {
    entityType: DefaultEntities.User,
    defaultValues: {
      "authProviderId": null,
      "emailVerified": false,
      "imageUrl": "",
      "isAdmin": false,
      "permissions": [],
      "serviceAccount": false,
      "state": UserState.Active,
    },
    requireExplicitWritePermissionFields: ["authProviderId", "emailVerified", "isAdmin", "serviceAccount", "state"],
    requireExplicitWritePermissionCustomPermissions: {
      "authProviderId": "custom:UpdateProtectedUserFields",
      "emailVerified": "custom:UpdateProtectedUserFields",
      "isAdmin": "custom:UpdateProtectedUserFields",
      "serviceAccount": "custom:UpdateProtectedUserFields",
      "state": "custom:UpdateProtectedUserFields",
    },
  },
};

export const entityInfos = {
  [DefaultEntities.Global]: {
    validContexts: [
      []
    ],
    pathTemplates: [
      `/`
    ],
    urlTemplate: "/",
  },
  [DefaultEntities.User]: {
    validContexts: [
      [CONTEXT_KEY(DefaultEntities.User)]
    ],
    pathTemplates: [
      `/User/<User>`
    ],
    urlTemplate: "/:user",
  },
  [Entities.ImportProcess]: {
    validContexts: [
      [CONTEXT_KEY(Entities.ImportProcess)]
    ],
    pathTemplates: [
      `/ImportProcess/<ImportProcess>`
    ],
    urlTemplate: "/:importProcess",
  },
  [Entities.Order]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Order)]
    ],
    pathTemplates: [
      `/Order/<Order>`
    ],
    urlTemplate: "/:order",
  },
  [Entities.Position]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Position)]
    ],
    pathTemplates: [
      `/Position/<Position>`
    ],
    urlTemplate: "/pos/:position",
  },
  [Entities.Preset]: {
    validContexts: [
      [CONTEXT_KEY(Entities.Preset)]
    ],
    pathTemplates: [
      `/Preset/<Preset>`
    ],
    urlTemplate: "/:preset",
  },
  [Entities.UserOption]: {
    validContexts: [
      [CONTEXT_KEY(Entities.UserOption)]
    ],
    pathTemplates: [
      `/UserOption/<UserOption>`
    ],
    urlTemplate: "/:userOption",
  },
};

export function getPathesForEntity<T extends keyof typeof entityInfos>(entity: T, name: string): string[] {
  const info = entityInfos[entity];
  return info?.pathTemplates.map((template: string) => `${template}/${name}`) ?? [];
}